import { StethoscopeIcon } from 'lucide-react';

import { getLocalizedSpeciality } from '@virtual-care/isomorphic';
import { Card, CardContent, DialogTrigger } from '@virtual-care/shadcn';

import { useLanguage } from '../../i18n/use-language.ts';
import { availableSpecialtyIcons } from '../utils/specialty-icons';

interface SpecialtyCardProps {
  specialty: {
    id: string;
    name: string;
    nameEn?: string | null;
    description: string;
    descriptionEn?: string | null;
  };
  onClick: () => void;
}

export function SpecialtyCard({ specialty, onClick }: SpecialtyCardProps) {
  const { language } = useLanguage();
  const display = getLocalizedSpeciality(specialty, language);

  return (
    <DialogTrigger asChild onClick={onClick}>
      <Card className="cursor-pointer border border-gray-200 bg-white transition-all duration-300 hover:border-blue-300 hover:shadow-lg">
        <CardContent className="px-4">
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
              <div className="bg-tertiary flex-shrink-0 rounded-full p-2">
                {availableSpecialtyIcons.includes(specialty.name) ? (
                  <img
                    src={`/specilities-icons/${specialty.name}.svg`}
                    alt={display.name}
                    className="h-5 w-5 object-contain brightness-0 invert"
                  />
                ) : (
                  <StethoscopeIcon className="h-5 w-5 text-white" />
                )}
              </div>
              <h3 className="font-semibold text-gray-900">{display.name}</h3>
            </div>
            <p className="text-sm leading-relaxed text-gray-600">
              {display.description}
            </p>
          </div>
        </CardContent>
      </Card>
    </DialogTrigger>
  );
}
